import { EFeedbackFormActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const disableLoadForm = actionGenerator(EFeedbackFormActionType.LoadFormDisabled);
